<div class="container" #form>
    <div class="row header">
        <div mat-dialog-title style="width: 92%;">
            {{ 'opcodeServiceManagement.createService' | translate }}
        </div>
        <div class="icon" (click)="close()">
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<form  [formGroup]="opcodeForm">
    <div class="container-fluid">
        <div class="row" style="padding-top: 0.6rem;">
            <div class="col-md-6">
                <div>{{ 'opcodeServiceManagement.enterNewServiceCode' | translate }}<span style="color:red">*</span></div>
                <mat-form-field style="width: 95%;" appearance="outline">
                    <input matInput  formControlName='opcode' type="text"
                    autocomplete="off" onkeypress="return event.charCode != 32"> 
                </mat-form-field>
                <mat-error *ngIf="hasTouched('opcode') && hasError('opcode','required')">{{ 'opcodeServiceManagement.serviceCodeIsRequired' | translate }}</mat-error>
                <mat-error *ngIf="!hasError('opcode','required') && (isOpcodeExists)" [ngClass]="!isEnglishText ? 'custom-fontSize' :''">{{ 'opcodeServiceManagement.thisOpcodeIsAlreadyExisting' | translate }}</mat-error>   
            </div>
            <div class="field-right">
                <label class="mb-0">{{'opcodeServiceManagement.mapDmsOpcode' | translate}}<span style="color: red;">*</span></label>
                <div *ngIf="!dmsCode.value.isDmsCodeSaved">
            
                    <mat-form-field appearance="outline" formGroupName="mapDmsCode">
                        <input type="text" placeholder="Enter DMS Code" #dmsOpcode matInput formControlName="opcodeOption"
                            [matAutocomplete]="auto" (input)="filter(dmsOpcode.value)" (keyup.enter)="mapDmsOpcode()">
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of filteredOptions" [value]="option.opcode" title="{{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}">
                                {{option.opcode}} | {{option?.displayName ? option?.displayName : option.dmsDescription}}
                            </mat-option>
                        </mat-autocomplete>
            
                        <mat-error *ngIf="dmsCode.controls['opcode'].hasError('required')">
                            {{'generalSettings.pleaseEnterValue' | translate}}
                        </mat-error>
            
                        <mat-icon class="add-new-code" (click)="mapDmsOpcode()"
                            (keydown.enter)="mapDmsOpcode()"
                            [ngClass]="!dmsCode.value.opcodeOption ? 'disabled' : ''">add</mat-icon>
                    </mat-form-field>
                </div>
            
                <div *ngIf="dmsCode.value.opcode && dmsCode.value.isDmsCodeSaved" class="d-flex">
                    <div style="width: 70%">
                        <span>{{dmsCode.value.opcode}}</span>
                    </div>
                    <div style="width: 15%" class="d-flex">
                        <asp-icon [matTooltip]="'opcodeServiceManagement.editDmsOpcode' | translate" matTooltipClass="asp-custom-tooltip"
                            color='rgba(14,19,25,0.8)' height='0.8rem' name="ic-20-utility-edit.svg" width="0.8rem"
                            style="padding-right: 0.5rem; cursor: pointer;" (click)="onEditDmsOpcode()"></asp-icon>
                        <div class="icons">
                            <asp-icon [matTooltip]="'opcodeServiceManagement.deleteDmsOpcode' | translate" matTooltipClass="asp-custom-tooltip"
                                class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                                color='rgba(14,19,25,0.8)' style="cursor: pointer" (click)="onDeleteDmsOpcode()">
                            </asp-icon>
                        </div>
                    </div>
            
                </div>
            </div>
        </div>
         <div class="row">
            <div class="col-md-12">
                <div class="field-left">
                    <label>{{ 'opcodeServiceManagement.displayName' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field style="width:95%" appearance="outline">
                        <input matInput formControlName="displayName" type="text"
                            autocomplete="off" maxlength="250">
                    </mat-form-field>
                    <mat-error *ngIf="hasTouched('displayName') && hasError('displayName','required')">{{ 'opcodeServiceManagement.displaynameIsRequired' | translate }}</mat-error>
                </div>
                <div class="field-right">
                    <div style="padding-bottom:0.5rem">{{ 'opcodeServiceManagement.mileage' | translate }}</div>
                    <mat-form-field style="width:97%" appearance="outline" style="width:95%">
                        <mat-select formControlName="mileages" placeholder="{{ 'opcodeServiceManagement.selectMileage' | translate }}">
                            <mat-option [value]="''">{{ 'opcodeServiceManagement.selectMileage' | translate }}</mat-option>
                            <mat-option [value]="mileage" *ngFor="let mileage of (mileages$ | async)">{{mileage}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('mileages','required')">{{'service.mileageIsRequired' | translate }}</mat-error>
                </div>
            </div>
        </div> 
        <div class="row">
            <div class="col-md-12">
                    <label >{{ 'opcodeServiceManagement.detailedDescription' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field style="width:98%" class="no-fixed-height" appearance="outline">
                        <textarea matInput class="description" formControlName="description"
                            maxlength="1000"></textarea>
                    </mat-form-field> 
                    <mat-error *ngIf="hasTouched('description') && hasError('description','required')">{{ 'opcodeServiceManagement.detailedDescriptionIsRequired' | translate }}</mat-error>
              </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="field-start" [ngClass]="!isEnglishText ? 'custom-width' :''">
                    <label>{{ 'opcodeServiceManagement.estimatedDuration(H)' | translate }}<span style="color:red">*</span></label>
            <mat-form-field appearance="outline">
                <input matInput formControlName="labourHours" type="number">
            </mat-form-field>
            <mat-error *ngIf="hasTouched('labourHours') && hasError('labourHours','required')">{{ 'opcodeServiceManagement.durationIsRequired' | translate }}</mat-error>
            <mat-error *ngIf="hasError('labourHours','min')">{{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong></mat-error>
                </div>
                <div class="field-middle">
                    <label >{{ 'opcodeServiceManagement.opcodeType' | translate }}<span style="color: red;">*</span></label>
                    <mat-form-field appearance="outline" style="width:93%">
                        <mat-select formControlName="opcodeType" placeholder="{{ 'opcodeServiceManagement.selectType' | translate }}">
                            <mat-option value="repair" (click)="removeMileageValidation()" >{{ 'opcodeServiceManagement.complaint' | translate }}</mat-option>
                            <mat-option value="maintenance" (click)="addMileageValidation()" >{{ 'opcodeServiceManagement.maintenance' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="hasError('opcodeType','required') && hasTouched('opcodeType')">{{'opcodeServiceManagement.serviceTypeIsRequired' | translate }}</mat-error>
                </div>
                <div class="field-end">
                    <div></div>
                  <mat-checkbox formControlName="commentsEnabled" class="text-nowrap">
                      <span>{{ 'opcodeServiceManagement.userComments' | translate }}</span>
                  </mat-checkbox>
                  <mat-checkbox formControlName="commentsRequired" [disabled]="!commentsEnabledField.value" class="text-nowrap">
                      <span>{{ 'opcodeServiceManagement.commentsRequired' | translate }}</span>
                  </mat-checkbox>
                </div>
            </div>
        </div> 
        <div class="row">
            <div style="width: 63.5%; margin-left: 2.5%;">
                <div class="field-container" formGroupName="pricing">
                    <div class="field-right">
                        <div>{{ 'opcodeServiceManagement.price' | translate }}</div>
                        <mat-form-field style="width:90%" appearance="outline">
                            <mat-select formControlName="pricingType">
                                <mat-option [value]="pricingType.FIXED">{{ 'opcodeServiceManagement.fixed' | translate }}</mat-option>
                                <mat-option [value]="pricingType.STARTS_AT">{{ 'opcodeServiceManagement.startingAt' | translate }}</mat-option>
                                <mat-option [value]="pricingType.RANGE">{{ 'opcodeServiceManagement.priceRange' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="priceValue" *ngIf="opcodeForm.get('pricing.pricingType').value === pricingType.FIXED">
                        {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                        <mat-form-field appearance="outline">
                            <input matInput formControlName='fixed'
                                type="number" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="priceValue" *ngIf="opcodeForm.get('pricing.pricingType').value === pricingType.STARTS_AT">
                        {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="startsAt" type="number"
                                autocomplete="off">
                        </mat-form-field>
                    </div>
                <div class="range" formGroupName="range" *ngIf="opcodeForm.get('pricing.pricingType').value === pricingType.RANGE">
                    {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                    <mat-form-field style="width:30%" appearance="outline">
                        <input matInput formControlName="from" type="number" autocomplete="off">
                    </mat-form-field>

                    <span style="padding-right:0.6rem; padding-left: 0.4rem;"> {{ 'opcodeServiceManagement.to ' | translate }} </span>

                    {{'GLOBAL.CURRENCYSYMBOL' | translate }}
                    <mat-form-field appearance="outline" style="width:30%; ">
                        <input matInput  formControlName="to" type="number" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>
                
        </div>

        <div class="status">
            <div class="text" [ngClass]="isEnglishText ? 'custom-margin' :''">{{ 'opcodeServiceManagement.status' | translate }}</div>
            <div class="switch" [ngClass]="isEnglishText ? 'custom-margin' :''">
                <app-onofswitch [switchInput]="opcodeForm.get('isVisible').value"
                    (switchChange)="updateSwitchValues($event)">
                </app-onofswitch>
            </div>
        </div>
        </div>
        
        <div class="row">
                <div class="controls">
                    <h6 *ngIf="clickedOutside" style="color:red;margin:auto;margin-left:1rem;">
                    <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
                    {{'servicePersonnel.alertMessage'| translate}}</h6>
                    <div class="cancel" [ngClass] = "opcodeForm.dirty ? 'enabled' : ''"   (click)="close()">{{ 'overrideCapacity.cancel' | translate }}</div>
                    <div class="save" [ngClass] = "(isValidForm() && !(isCheckOpcodesLoading) && !(isOpcodeExists) ) ? 'enabled' : ''"  (click)="submitForm()">{{ 'overrideCapacity.save' | translate }}</div>
                </div>
        </div>
    </div>
    
</form>
